import { useMemo } from 'react';
import styles from './PlayMessageButton.module.scss';
import classes from 'classnames';

interface PlayMessageButtonProps {
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  speaking?: boolean;
  speaked?: boolean;
  onClick: () => void;
}

const PlayMessageButton = ({
  className = '',
  disabled = false,
  loading = false,
  speaking = false,
  speaked = false,
  onClick,
}: PlayMessageButtonProps) => {
  const svgClassName = useMemo(() => {
    return loading ? styles.loading : speaking ? styles.speaking : speaked ? styles.speaked : '';
  }, [loading, speaking, speaked]);

  return (
    <button onClick={onClick} disabled={disabled} className={classes(styles.button, className)}>
      <svg viewBox='0 0 24 24' className={svgClassName}>
        <g className={styles.arrow}>
          <ellipse cx='12' cy='12' rx='9.5' ry='9.5' />
          <path />
        </g>
        <path className={styles.icon} />
      </svg>
    </button>
  );
};

export default PlayMessageButton;
